import { useQuery } from '@apollo/client';

import { useParams } from 'js/lib/useRouter';

import UseDegreeQuery from 'bundles/degree-home/utils/__queries__/DegreeHomeDegreeBySlug.graphql';
import type {
  DegreeHomeDegreeBySlugQuery,
  DegreeHomeDegreeBySlugQueryVariables,
} from 'bundles/degree-home/utils/__queries__/__generated__/DegreeHomeDegreeBySlug';

/** Get all details about the current degree-home degree */
const useDegree = () => {
  const { degreeSlug } = useParams();

  return useQuery<DegreeHomeDegreeBySlugQuery, DegreeHomeDegreeBySlugQueryVariables>(UseDegreeQuery, {
    variables: {
      slug: degreeSlug,
    },
    context: { clientName: 'gatewayGql' },
  });
};

export default useDegree;
